export default __webpack_public_path__ + "static/media/image12.6051018e.png";